import React from "react";
import "../style/about.scss";
import aboutImg from "../img/3.svg";
import LinkButton from "../components/LinkButton";
import ActionSection from "../components/ActionSection";

export default function About() {
  return (
    <>
      <div
        style={{ borderRadius: "0 0 30px 30px" }}
        className="container banner p-30"
      >
        <div className="wrapper title-box p-30">
          <h1 className="title" data-aos="fade-down">
            O Meni - Heli Brows
          </h1>
          <h2
            className="subtitle"
            data-aos="fade-down"
          >
            Moja priča
          </h2>
        </div>
      </div>

      <div className="p-30 wrapper about-content">
        <img data-aos="fade-right" src={aboutImg} alt="Puder obrve - Savršene za prirodan izgled" />

        <div>
          <h2 data-aos="fade-left">Moja priča</h2>

          <p data-aos="fade-left" data-aos-duration="1500">
            Verujem da su lepo oblikovane obrve ključ suptilne, ali moćne
            promene koja ističe vašu prirodnu lepotu! Iza brenda Heli Brows
            stoji Helena Božović, sertifikovani brow artist, posvećen isticanju
            prirodne lepote svojih klijenata.
          </p>

          <p data-aos="fade-left" data-aos-duration="2000">
            Ljubav prema estetici i pažnja prema detaljima inspirisale su me da
            se posvetim tehnici puder obrva, koja pruža dugotrajan i
            sofisticiran efekat. Kroz profesionalni pristup, preciznost i
            korišćenje vrhunskih tehnika i materijala, garantujem kvalitet i
            besprekorne rezultate. Svakom klijentu pristupam individualno,
            vodeći računa o njegovim željama, obliku lica i prirodnim crtama,
            kako bih postigla što prirodniji i harmoničniji izgled.
          </p>
          <p data-aos="fade-left" data-aos-duration="2500">
            U svom radu naglašavam preciznost, pažljivost i posvećenost
            detaljima, jer verujem da male promene mogu doneti veliku razliku u
            samopouzdanju. Svaka osoba zaslužuje obrve koje će joj olakšati
            svakodnevicu i doprineti njenoj prirodnoj lepoti. Ako sanjate o
            besprekorno oblikovanim, prirodno istaknutim obrvama koje traju, tu
            sam da vam pomognem da postignete svoj savršeni izgled!
          </p>

          <div data-aos="fade-left">
            <LinkButton link="/kontakt" buttonText="Zakaži termin" />
          </div>
        </div>
      </div>
      <ol className="wrapper" style={{ fontSize: 18 }}>
        <li data-aos="fade-right">
          <span>Strast prema poslu </span> <br />
          Svoju strast prema estetici i detaljima pretvorila sam u profesiju, jer verujem da pravi rezultati dolaze kada radiš ono što voliš.{" "}
          
        </li>
        <li data-aos="fade-left">
          <span>Stalno usavršavanje </span> <br />
          Uvek težim napretku – edukacije, nove tehnike i usavršavanje su mi
          prioritet, jer želim da klijentima pružim{" "}
          najbolje i najsavremenije tretmane.
        </li>
        <li data-aos="fade-right">
          <span>Pristupačnost i poverenje </span> <br />
          Verujem u topao i prijateljski pristup, jer mi je važno da se svaka osoba na mom tretmanu oseća opušteno, sigurno i zadovoljno svojim izgledom.{" "}
          
        </li>
      </ol>

      <div data-aos="zoom-in">
        <ActionSection />
      </div>
    </>
  );
}
